<template>
    <div>
        <b-container fluid>
            <h3 class="mt-3 mb-3">Fulfillment Analytics Dashboard</h3>

            <!-- Filters Section -->
            <b-card class="mb-2">
                <b-row>
                    <b-col cols="12" sm="6" md="3">
                        <b-form-group label="Client">
                            <b-form-select v-model="filters.client_id" :options="clientOptions"></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="3">
                        <b-form-group label="Start Date">
                            <b-form-input type="date" v-model="filters.start_date" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="3">
                        <b-form-group label="End Date">
                            <b-form-input type="date" v-model="filters.end_date" />
                        </b-form-group>
                    </b-col>
                    <!-- <b-col cols="12" sm="6" md="3">
                        <b-form-group label="Output Mode">
                            <b-form-select v-model="filters.output_mode" :options="outputModes" />
                        </b-form-group>
                    </b-col> -->
                </b-row>
                <b-button variant="primary" @click="fetchAnalytics">Get Analytics</b-button>
            </b-card>

            <!-- Metrics Section -->
            <b-row class="mb-2">
                <b-col cols="6">
                    <b-card title="Total # of Orders">
                        <h1 class="text-center">{{ totalOrders }}</h1>
                    </b-card>
                </b-col>
                <b-col cols="6">
                    <b-card title="Average Fulfillment Rate">
                        <h1 class="text-center">{{ averageFulfillmentRate }}%</h1>
                    </b-card>
                </b-col>
            </b-row>

            <!-- Fulfillment Trend Charts -->
            <b-row>
                <b-col cols="12">
                    <b-card title="Order Status" class="mb-2">
                        <apexchart type="bar" height="350" :options="barChartOptions" :series="barChartSeries">
                        </apexchart>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <b-card title="Fulfillment Rate">
                        <apexchart type="line" height="350" :options="lineChartOptions" :series="lineChartSeries">
                        </apexchart>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <b-card title="Delivery Lead Time">
                        <apexchart type="bar" height="350" :options="deliveryLeadtimeChartOptions"
                            :series="deliveryLeadtimeChartSeries">
                        </apexchart>
                    </b-card>
                </b-col>
            </b-row>

        </b-container>
    </div>
</template>
<script>
import moment from "moment";
import apiService from "../services/ApiService";
import global_function from "../mixins/global_function";

export default {
    inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
    mixins: [apiService, global_function],
    data() {
        const currentMonthStart = moment().startOf("month").format("YYYY-MM-DD");
        const currentMonthEnd = moment().endOf("month").format("YYYY-MM-DD");

        return {
            loader: false,
            filters: {
                client_id: 8,
                start_date: currentMonthStart,
                end_date: currentMonthEnd,
                output_mode: "JSON",
            },
            clientOptions: [{ value: null, text: "Select Client" }, { value: 8, text: "DCS" }, { value: 22, text: "LTM" }],
            outputModes: [{ value: "JSON", text: "Dashboard" }, { value: "XLS", text: "Excel" }],
            chartData: [],
            totalOrders: 0,
            averageFulfillmentRate: 0,
            barChartSeries: [],
            barChartOptions: {},
            lineChartSeries: [],
            lineChartOptions: {},
            chart_deliveryLeadtime: [],
            deliveryLeadtimeChartSeries: [],
            deliveryLeadtimeChartOptions: {},
        };
    },
    methods: {

        async fetchAnalytics() {
            this.loader = this.$loading.show({
                isFullPage: true,
                canCancel: false,
            });
            try {
                const response = await this.$http({
                    method: "POST",
                    baseURL: `${this.API_HOST}`,
                    url: "fulfilment_analytics_get.php",
                    data: this.filters,
                    headers: { "Content-Type": "application/json" },
                });

                this.chartData = response.data.chart_data || [];
                this.chart_deliveryLeadtime = response.data.chart_deliveryLeadtime || {};
                this.calculateMetrics();
                this.prepareBarChart();
                this.prepareLineChart();
                this.prepareDeliveryLeadtimeChart();

                this.loader.hide();
            } catch (error) {
                console.error("Error fetching analytics:", error);
            }
        },

        async _fetchAnalytics() {
            try {
                // Mock response
                let response = {};
                response.data = {
                    "deliveryLeadtime": {
                        "0": 7313,
                        "1": 487,
                        "3": 31,
                        "2": 201,
                        "4": 9,
                        "14": 1
                    },
                    "fulfillmentLeadtime": [
                        7528,
                        384,
                        92,
                        38
                    ],
                    "fulfillmentByDaysNonHKTVMALL": {
                        "2024-09-02": {
                            "2024-09-02": 661
                        },
                        "2024-09-03": {
                            "2024-09-02": 220,
                            "2024-09-03": 215
                        },
                        "2024-09-04": {
                            "2024-09-02": 13,
                            "2024-09-03": 141,
                            "2024-09-04": 351
                        },
                        "2024-09-05": {
                            "2024-09-03": 78,
                            "2024-09-04": 154
                        },
                        "2024-09-06": {
                            "2024-09-03": 1,
                            "2024-09-04": 1,
                            "2024-09-05": 143,
                            "2024-09-06": 122
                        },
                        "2024-09-07": {
                            "2024-09-04": 37
                        },
                        "2024-09-11": {
                            "2024-09-06": 1,
                            "2024-09-11": 174
                        },
                        "2024-09-09": {
                            "2024-09-09": 504
                        },
                        "2024-09-10": {
                            "2024-09-09": 2,
                            "2024-09-10": 175
                        },
                        "2024-09-13": {
                            "2024-09-10": 1,
                            "2024-09-13": 191
                        },
                        "2024-09-12": {
                            "2024-09-12": 178
                        },
                        "2024-09-16": {
                            "2024-09-16": 472
                        },
                        "2024-09-17": {
                            "2024-09-17": 139
                        },
                        "2024-09-19": {
                            "2024-09-19": 361
                        },
                        "2024-09-20": {
                            "2024-09-19": 2,
                            "2024-09-20": 219
                        },
                        "2024-09-23": {
                            "2024-09-23": 531
                        },
                        "2024-09-24": {
                            "2024-09-24": 189
                        },
                        "2024-09-25": {
                            "2024-09-25": 201
                        },
                        "2024-09-26": {
                            "2024-09-26": 221
                        },
                        "2024-09-27": {
                            "2024-09-27": 206
                        },
                        "2024-09-30": {
                            "2024-09-30": 544
                        }
                    },
                    "fulfillmentByDaysHKTVMALL": {
                        "2024-09-10": 50,
                        "2024-09-02": 80,
                        "2024-09-03": 44,
                        "2024-09-07": 105,
                        "2024-09-13": 65,
                        "2024-09-04": 60,
                        "2024-09-05": 48,
                        "2024-09-06": 12,
                        "2024-09-26": 54,
                        "2024-09-12": 62,
                        "2024-09-14": 94,
                        "2024-09-21": 88,
                        "2024-09-19": 84,
                        "2024-09-11": 63,
                        "2024-09-09": 73,
                        "2024-09-17": 43,
                        "2024-09-16": 67,
                        "2024-09-20": 79,
                        "2024-09-18": 15,
                        "2024-09-23": 64,
                        "2024-09-24": 37,
                        "2024-09-27": 79,
                        "2024-09-25": 43,
                        "2024-09-28": 93,
                        "2024-09-30": 92
                    },
                    "orderBreachData": {
                        "2024-08-30": {
                            "Ready_for_shipment_Date": "2024-08-30",
                            "Order_Fulfilled": 8,
                            "Count_>1_Day": 0,
                            "Breach_KPI": 0
                        },
                        "2024-09-02": {
                            "Ready_for_shipment_Date": "2024-09-02",
                            "Order_Fulfilled": 744,
                            "Count_>1_Day": 0,
                            "Breach_KPI": 0
                        },
                        "2024-09-03": {
                            "Ready_for_shipment_Date": "2024-09-03",
                            "Order_Fulfilled": 472,
                            "Count_>1_Day": 0,
                            "Breach_KPI": 0
                        },
                        "2024-09-04": {
                            "Ready_for_shipment_Date": "2024-09-04",
                            "Order_Fulfilled": 601,
                            "Count_>1_Day": 13,
                            "Breach_KPI": 0
                        },
                        "2024-09-05": {
                            "Ready_for_shipment_Date": "2024-09-05",
                            "Order_Fulfilled": 240,
                            "Count_>1_Day": 78,
                            "Breach_KPI": 78
                        },
                        "2024-09-06": {
                            "Ready_for_shipment_Date": "2024-09-06",
                            "Order_Fulfilled": 313,
                            "Count_>1_Day": 2,
                            "Breach_KPI": 2
                        },
                        "2024-09-07": {
                            "Ready_for_shipment_Date": "2024-09-07",
                            "Order_Fulfilled": 142,
                            "Count_>1_Day": 37,
                            "Breach_KPI": 37
                        },
                        "2024-09-09": {
                            "Ready_for_shipment_Date": "2024-09-09",
                            "Order_Fulfilled": 581,
                            "Count_>1_Day": 0,
                            "Breach_KPI": 0
                        },
                        "2024-09-10": {
                            "Ready_for_shipment_Date": "2024-09-10",
                            "Order_Fulfilled": 189,
                            "Count_>1_Day": 0,
                            "Breach_KPI": 0
                        },
                        "2024-09-11": {
                            "Ready_for_shipment_Date": "2024-09-11",
                            "Order_Fulfilled": 240,
                            "Count_>1_Day": 0,
                            "Breach_KPI": 0
                        },
                        "2024-09-12": {
                            "Ready_for_shipment_Date": "2024-09-12",
                            "Order_Fulfilled": 281,
                            "Count_>1_Day": 0,
                            "Breach_KPI": 0
                        },
                        "2024-09-13": {
                            "Ready_for_shipment_Date": "2024-09-13",
                            "Order_Fulfilled": 259,
                            "Count_>1_Day": 0,
                            "Breach_KPI": 0
                        },
                        "2024-09-14": {
                            "Ready_for_shipment_Date": "2024-09-14",
                            "Order_Fulfilled": 92,
                            "Count_>1_Day": 0,
                            "Breach_KPI": 0
                        },
                        "2024-09-16": {
                            "Ready_for_shipment_Date": "2024-09-16",
                            "Order_Fulfilled": 528,
                            "Count_>1_Day": 0,
                            "Breach_KPI": 0
                        },
                        "2024-09-17": {
                            "Ready_for_shipment_Date": "2024-09-17",
                            "Order_Fulfilled": 167,
                            "Count_>1_Day": 0,
                            "Breach_KPI": 0
                        },
                        "2024-09-19": {
                            "Ready_for_shipment_Date": "2024-09-19",
                            "Order_Fulfilled": 482,
                            "Count_>1_Day": 0,
                            "Breach_KPI": 0
                        },
                        "2024-09-20": {
                            "Ready_for_shipment_Date": "2024-09-20",
                            "Order_Fulfilled": 316,
                            "Count_>1_Day": 0,
                            "Breach_KPI": 0
                        },
                        "2024-09-21": {
                            "Ready_for_shipment_Date": "2024-09-21",
                            "Order_Fulfilled": 83,
                            "Count_>1_Day": 0,
                            "Breach_KPI": 0
                        },
                        "2024-09-23": {
                            "Ready_for_shipment_Date": "2024-09-23",
                            "Order_Fulfilled": 545,
                            "Count_>1_Day": 0,
                            "Breach_KPI": 0
                        },
                        "2024-09-24": {
                            "Ready_for_shipment_Date": "2024-09-24",
                            "Order_Fulfilled": 226,
                            "Count_>1_Day": 0,
                            "Breach_KPI": 0
                        },
                        "2024-09-25": {
                            "Ready_for_shipment_Date": "2024-09-25",
                            "Order_Fulfilled": 269,
                            "Count_>1_Day": 0,
                            "Breach_KPI": 0
                        },
                        "2024-09-26": {
                            "Ready_for_shipment_Date": "2024-09-26",
                            "Order_Fulfilled": 250,
                            "Count_>1_Day": 0,
                            "Breach_KPI": 0
                        },
                        "2024-09-27": {
                            "Ready_for_shipment_Date": "2024-09-27",
                            "Order_Fulfilled": 325,
                            "Count_>1_Day": 0,
                            "Breach_KPI": 0
                        },
                        "2024-09-28": {
                            "Ready_for_shipment_Date": "2024-09-28",
                            "Order_Fulfilled": 53,
                            "Count_>1_Day": 0,
                            "Breach_KPI": 0
                        },
                        "2024-09-30": {
                            "Ready_for_shipment_Date": "2024-09-30",
                            "Order_Fulfilled": 636,
                            "Count_>1_Day": 0,
                            "Breach_KPI": 0
                        }
                    },
                    "chart_data": [
                        {
                            "date": "2024-08-30",
                            "total_orders": 5,
                            "ready_for_shipment": 5,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-08-31",
                            "total_orders": 7,
                            "ready_for_shipment": 7,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-02",
                            "total_orders": 985,
                            "ready_for_shipment": 972,
                            "pending": 13,
                            "ready_for_shipment_percentage": 98.68
                        },
                        {
                            "date": "2024-09-03",
                            "total_orders": 472,
                            "ready_for_shipment": 393,
                            "pending": 79,
                            "ready_for_shipment_percentage": 83.26
                        },
                        {
                            "date": "2024-09-04",
                            "total_orders": 606,
                            "ready_for_shipment": 568,
                            "pending": 38,
                            "ready_for_shipment_percentage": 93.73
                        },
                        {
                            "date": "2024-09-05",
                            "total_orders": 203,
                            "ready_for_shipment": 203,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-06",
                            "total_orders": 185,
                            "ready_for_shipment": 185,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-07",
                            "total_orders": 63,
                            "ready_for_shipment": 63,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-08",
                            "total_orders": 49,
                            "ready_for_shipment": 49,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-09",
                            "total_orders": 547,
                            "ready_for_shipment": 547,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-10",
                            "total_orders": 210,
                            "ready_for_shipment": 210,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-11",
                            "total_orders": 233,
                            "ready_for_shipment": 233,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-12",
                            "total_orders": 247,
                            "ready_for_shipment": 247,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-13",
                            "total_orders": 259,
                            "ready_for_shipment": 259,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-14",
                            "total_orders": 61,
                            "ready_for_shipment": 61,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-16",
                            "total_orders": 551,
                            "ready_for_shipment": 551,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-17",
                            "total_orders": 174,
                            "ready_for_shipment": 174,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-18",
                            "total_orders": 39,
                            "ready_for_shipment": 39,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-19",
                            "total_orders": 434,
                            "ready_for_shipment": 434,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-20",
                            "total_orders": 294,
                            "ready_for_shipment": 294,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-21",
                            "total_orders": 71,
                            "ready_for_shipment": 71,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-23",
                            "total_orders": 598,
                            "ready_for_shipment": 598,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-24",
                            "total_orders": 227,
                            "ready_for_shipment": 227,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-25",
                            "total_orders": 244,
                            "ready_for_shipment": 244,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-26",
                            "total_orders": 291,
                            "ready_for_shipment": 291,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-27",
                            "total_orders": 294,
                            "ready_for_shipment": 294,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-28",
                            "total_orders": 60,
                            "ready_for_shipment": 60,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        },
                        {
                            "date": "2024-09-30",
                            "total_orders": 633,
                            "ready_for_shipment": 633,
                            "pending": 0,
                            "ready_for_shipment_percentage": 100
                        }
                    ],
                    "chart_deliveryLeadtime": {
                        "2024-08-30": {
                            "leadtimedelivery_0": 5,
                            "leadtimedelivery_1": 0,
                            "leadtimedelivery_>1": 0
                        },
                        "2024-08-31": {
                            "leadtimedelivery_0": 7,
                            "leadtimedelivery_1": 0,
                            "leadtimedelivery_>1": 0
                        },
                        "2024-09-02": {
                            "leadtimedelivery_0": 937,
                            "leadtimedelivery_1": 47,
                            "leadtimedelivery_>1": 1
                        },
                        "2024-09-03": {
                            "leadtimedelivery_0": 307,
                            "leadtimedelivery_1": 138,
                            "leadtimedelivery_>1": 27
                        },
                        "2024-09-04": {
                            "leadtimedelivery_0": 373,
                            "leadtimedelivery_1": 25,
                            "leadtimedelivery_>1": 208
                        },
                        "2024-09-05": {
                            "leadtimedelivery_0": 190,
                            "leadtimedelivery_1": 12,
                            "leadtimedelivery_>1": 1
                        },
                        "2024-09-06": {
                            "leadtimedelivery_0": 173,
                            "leadtimedelivery_1": 11,
                            "leadtimedelivery_>1": 1
                        },
                        "2024-09-07": {
                            "leadtimedelivery_0": 63,
                            "leadtimedelivery_1": 0,
                            "leadtimedelivery_>1": 0
                        },
                        "2024-09-08": {
                            "leadtimedelivery_0": 49,
                            "leadtimedelivery_1": 0,
                            "leadtimedelivery_>1": 0
                        },
                        "2024-09-09": {
                            "leadtimedelivery_0": 527,
                            "leadtimedelivery_1": 20,
                            "leadtimedelivery_>1": 0
                        },
                        "2024-09-10": {
                            "leadtimedelivery_0": 200,
                            "leadtimedelivery_1": 9,
                            "leadtimedelivery_>1": 1
                        },
                        "2024-09-11": {
                            "leadtimedelivery_0": 221,
                            "leadtimedelivery_1": 12,
                            "leadtimedelivery_>1": 0
                        },
                        "2024-09-12": {
                            "leadtimedelivery_0": 236,
                            "leadtimedelivery_1": 11,
                            "leadtimedelivery_>1": 0
                        },
                        "2024-09-13": {
                            "leadtimedelivery_0": 251,
                            "leadtimedelivery_1": 8,
                            "leadtimedelivery_>1": 0
                        },
                        "2024-09-14": {
                            "leadtimedelivery_0": 61,
                            "leadtimedelivery_1": 0,
                            "leadtimedelivery_>1": 0
                        },
                        "2024-09-16": {
                            "leadtimedelivery_0": 507,
                            "leadtimedelivery_1": 43,
                            "leadtimedelivery_>1": 1
                        },
                        "2024-09-17": {
                            "leadtimedelivery_0": 164,
                            "leadtimedelivery_1": 10,
                            "leadtimedelivery_>1": 0
                        },
                        "2024-09-18": {
                            "leadtimedelivery_0": 39,
                            "leadtimedelivery_1": 0,
                            "leadtimedelivery_>1": 0
                        },
                        "2024-09-19": {
                            "leadtimedelivery_0": 416,
                            "leadtimedelivery_1": 18,
                            "leadtimedelivery_>1": 0
                        },
                        "2024-09-20": {
                            "leadtimedelivery_0": 284,
                            "leadtimedelivery_1": 9,
                            "leadtimedelivery_>1": 1
                        },
                        "2024-09-21": {
                            "leadtimedelivery_0": 71,
                            "leadtimedelivery_1": 0,
                            "leadtimedelivery_>1": 0
                        },
                        "2024-09-23": {
                            "leadtimedelivery_0": 567,
                            "leadtimedelivery_1": 31,
                            "leadtimedelivery_>1": 0
                        },
                        "2024-09-24": {
                            "leadtimedelivery_0": 216,
                            "leadtimedelivery_1": 11,
                            "leadtimedelivery_>1": 0
                        },
                        "2024-09-25": {
                            "leadtimedelivery_0": 228,
                            "leadtimedelivery_1": 15,
                            "leadtimedelivery_>1": 1
                        },
                        "2024-09-26": {
                            "leadtimedelivery_0": 264,
                            "leadtimedelivery_1": 27,
                            "leadtimedelivery_>1": 0
                        },
                        "2024-09-27": {
                            "leadtimedelivery_0": 290,
                            "leadtimedelivery_1": 4,
                            "leadtimedelivery_>1": 0
                        },
                        "2024-09-28": {
                            "leadtimedelivery_0": 60,
                            "leadtimedelivery_1": 0,
                            "leadtimedelivery_>1": 0
                        },
                        "2024-09-30": {
                            "leadtimedelivery_0": 607,
                            "leadtimedelivery_1": 26,
                            "leadtimedelivery_>1": 0
                        }
                    }
                };

                this.chartData = response.data.chart_data || [];
                this.chart_deliveryLeadtime = response.data.chart_deliveryLeadtime || {};
                this.calculateMetrics();
                this.prepareBarChart();
                this.prepareLineChart();
                this.prepareDeliveryLeadtimeChart();
            } catch (error) {
                console.error("Error fetching analytics:", error);
            }
        },
        calculateMetrics() {
            let totalOrders = 0;
            let totalFulfillmentRate = 0;

            this.chartData.forEach((item) => {
                totalOrders += item.ready_for_shipment + item.pending;
                totalFulfillmentRate += item.ready_for_shipment_percentage;
            });

            this.totalOrders = totalOrders;
            this.averageFulfillmentRate = (totalFulfillmentRate / this.chartData.length).toFixed(2);
        },
        prepareBarChart() {
            const labels = this.chartData.map((item) => moment(item.date).format("DD MMM"));
            const readyForShipment = this.chartData.map((item) => item.ready_for_shipment);
            const pending = this.chartData.map((item) => item.pending);

            this.barChartSeries = [
                { name: "Ready for Shipment", data: readyForShipment },
                { name: "Pending", data: pending },
            ];

            this.barChartOptions = {
                chart: { stacked: true },
                xaxis: {
                    categories: labels,
                    labels: {
                        rotate: -30, // Slightly rotated for better readability
                        rotateAlways: true,
                        style: {
                            fontSize: "12px",
                            fontWeight: 400,
                        },
                    },
                },

                colors: ["#00E396", "#FF4560"], // Green, Red
                tooltip: { shared: true },
            };
        },
        prepareLineChart() {
            const labels = this.chartData.map((item) => moment(item.date).format("DD MMM"));
            const fulfillmentRate = this.chartData.map((item) => item.ready_for_shipment_percentage);

            this.lineChartSeries = [{ name: "Fulfillment Rate (%)", data: fulfillmentRate }];

            this.lineChartOptions = {
                chart: { height: 350 },
                xaxis: {
                    categories: labels,
                    labels: {
                        rotate: -30, // Slightly rotated for better readability
                        rotateAlways: true,
                        style: {
                            fontSize: "12px",
                            fontWeight: 400,
                        },
                    },
                },

                colors: ["#008FFB"], // Blue
                yaxis: {
                    title: { text: "Percentage (%)" },
                    max: 100,
                    min: 0,
                },
            };
        },

        prepareDeliveryLeadtimeChart() {
            const labels = Object.keys(this.chart_deliveryLeadtime).map(date => moment(date).format("DD MMM"));
            const leadtime0 = Object.values(this.chart_deliveryLeadtime).map(data => data.leadtimedelivery_0);
            const leadtime1 = Object.values(this.chart_deliveryLeadtime).map(data => data.leadtimedelivery_1);
            const leadtimeMoreThan1 = Object.values(this.chart_deliveryLeadtime).map(data => data.leadtimedelivery_ > 1);

            this.deliveryLeadtimeChartSeries = [
                { name: "Lead Time 0", data: leadtime0 },
                { name: "Lead Time 1", data: leadtime1 },
                { name: "Lead Time >1", data: leadtimeMoreThan1 },
            ];

            this.deliveryLeadtimeChartOptions = {
                chart: { stacked: true },
                xaxis: {
                    categories: labels,
                    labels: {
                        rotate: -30, // Slightly rotated for better readability
                        rotateAlways: true,
                        style: {
                            fontSize: "12px",
                            fontWeight: 400,
                        },
                    },
                },
                colors: ["#00E396", "#FEB019", "#FF4560"], // Green, Orange, Red
                tooltip: { shared: true },
            };
        }

    },
};
</script>



// WEBPACK FOOTER //
// src/components/FulfillmentAnalytics.vue